import * as XLSX from "xlsx"
import { saveAs } from "file-saver"
import { Boton } from "asocomponents" 

const ExportarExcel = ({ data, nombreArchivo, camposSeleccionados  }) => {

  const handleExport = () => {
    if (!data || !Array.isArray(data) || data.length === 0) {
      alert("No hay datos para exportar")
      return
    }

    if (!camposSeleccionados || camposSeleccionados.length === 0) {
      alert("No se han especificado campos para exportar")
      return
    }

    // Filtrar las propiedades seleccionadas
    const filteredData = data.map(item =>
      camposSeleccionados.reduce((acc, field) => {
        acc[field] = item[field] || ""
        return acc
      }, {})
    )

    // Crear una hoja de cálculo a partir de los datos filtrados
    const worksheet = XLSX.utils.json_to_sheet(filteredData)

    // Crear un libro de trabajo
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, "Datos")

    // Generar el archivo Excel
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" })

    // Descargar el archivo
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" })
    saveAs(blob, `${nombreArchivo || "data"}.xlsx`)
  }

  return (
    <Boton onClick={handleExport} type="button" icono="excel" texto="Exportar" fondo="gris" height="h-7" colorIcon="#000000"/>
  )
}

export default ExportarExcel